export default __webpack_public_path__ + "static/media/mobile-image-hero-3.601d0f37.jpg";